import React from "react";
import "../../global.scss";
import { IonLabel, IonInput } from "@ionic/react";
import { COUNTRY_CODE } from "../../constants";

const CustomTextField: React.FC = (props: any) => {
	return (
		<div className={props.changeStyle ? "login18 displayflex" : "login18"}>
			<IonLabel className="login19" color="secondary">
				{props.label}
			</IonLabel>
			<div className="login20">
				<IonLabel className="login21" color="tertiary">
					{COUNTRY_CODE}
				</IonLabel>
				<input
					type="tel"
					max={9}
					onChange={(event) =>
						/^\d+$/.test(event.target.value) || !event.target.value
							? props.onChange(event.target.value)
							: null
					}
					onKeyPress={(event) => props.handleKeypress(event)}
					value={props.value}
					className="mobile-number-input"
				/>
			</div>
		</div>
	);
};
export default CustomTextField;
